import Moment from 'moment'

export function validateEmail(email) {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return regex.test(email)
}

export function validatePhone(phone) {
  const regex = /^\(\d{2}\) \d{5}-\d{4}$/
  return regex.test(phone)
}

export function validateBothPhoneNumbers(phone) {
  const regex = /^\(\d{2}\) \d{5}-\d{3,4}$/
  return regex.test(phone)
}

export function validateBirthday(birthday) {
  const dateObj = Moment(birthday, 'DD/MM/YYYY', true)
  if (!dateObj.isValid()) {
    return false
  }
  const age = Moment().diff(dateObj, 'years')
  return age >= 16 && age <= 120
}

export const passwordRules = [
  {
    description: 'Deve ter no mínimo <strong>8 caracteres</strong>',
    validator: password => password.length >= 8
  },
  {
    description: 'Deve ter pelo menos uma <strong>letra maiúscula</strong>',
    validator: password => /[A-Z]/.test(password)
  },
  {
    description: 'Deve ter pelo menos uma <strong>letra minúscula</strong>',
    validator: password => /[a-z]/.test(password)
  },
  {
    description: 'Deve ter pelo menos um <strong>número</strong>',
    validator: password => /\d/.test(password)
  }
]
